import type { Bordereau, Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BaseBordereauState from './BaseBordereauState';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import BordereauRelancerFluxAction from '../actions/BordereauRelancerFluxAction';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import BordereauActualiseEtatAction from '../actions/BordereauActualiseEtatAction';

class BordereauPesEnInstanceState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.PES_EN_INSTANCE;
    this.state = BordereauStateType.PES_EN_INSTANCE;
    this.color = '#FFA742';
    this.libelle = 'PES en instance';
  }

  getBordereauActions(_bordereau : Bordereau): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    return [
      new BordereauRelancerFluxAction(),
      new BordereauDupliquerAction(),
      new BordereauActualiseEtatAction(),
    ];
  }

  getMouvementActions(userRole : UserRole): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
      new MouvementModifierAction({ isReadonly: true }),
      ...(userRole === UserRole.ADMIN) ? [
        new MouvementModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }
}

export default BordereauPesEnInstanceState;
